import api from './axios';

// Single action to update online status and send heartbeat
export const updateOnlineStatus = async (token, isOnline = true) => {
    if (!token) {
        throw new Error('Token is required for updating online status');
    }

    try {
        const response = await api.post('/api/v2/user/online', {
            isOnline,
            lastSeen: new Date().toISOString(),
        });

        return {
            success: true,
            lastSeen: response.data.lastSeen,
            timestamp: Date.now(),
            data: response.data
        };
    } catch (error) {
        console.error('Failed to update online status:', error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};
